const VerticalLayout = () => import('@/layouts/VerticalLayout')

const pricing = () => import('./views/index')
const ticketsList = () => import('./views/tickets')
const promotionslist = () => import('./views/promotions')
const couponsList = () => import('./views/coupons')

// Tabs of this page, in display order; a tab the account can't open falls back to the next allowed one.
const fallbackRoutes = ['pricing.tickets', 'pricing.promotions', 'pricing.coupons']

export default [
  {
    path: '/pricing',
    name: 'pricing',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'pricing',
      component: pricing,
      redirect: { name: 'pricing.tickets' },
      meta: { name: 'pricing', userType: 'provider', serviceTypes: 'all', permission: ['ticket_list', 'promotion_list', 'coupon_list'] },
      children: [
        {
          path: 'tickets',
          name: 'pricing.tickets',
          component: ticketsList,
          meta: { name: 'tickets', userType: 'provider', serviceTypes: 'all', permission: 'ticket_list', fallbackRoutes }
        },
        {
          path: 'promotions',
          name: 'pricing.promotions',
          component: promotionslist,
          meta: { name: 'promotions', userType: 'provider', serviceTypes: 'all', permission: 'promotion_list', fallbackRoutes }
        },
        {
          path: 'coupons',
          name: 'pricing.coupons',
          component: couponsList,
          meta: { name: 'coupons', userType: 'provider', serviceTypes: 'all', permission: 'coupon_list', fallbackRoutes }
        }
      ]
    }]
  }
]
